/** @module Auth0CodedError */

class Auth0CodedError extends Error {
  /**
   * @constructor
   * @description A lot of exceptions here need a bit of differentiation when considering requests that result in a status code. FOr instance, many requests can result in 401 or 403 and, as such, use this type of error to differentiate bu a special code
   * @extends Error
   * @param {string} msg The details of the error
   * @param {int} code The unique code representing the error or class of error
   */
  constructor(msg, code) {
    super(msg);
    this.code = code;
    this.name = Auth0CodedError.name;
  }
}

export default Auth0CodedError;
